<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="toc" id="toc">
<h1 class="ctfm"><a class="page" id="pvi"></a><a class="page" id="pvii"></a>Contents</h1>
<p class="tocfmf"><a class="xref" href="#/ChiLeong0007#abbrs">Abbreviations</a></p>
<p class="toc"><a class="xref" href="#/ChiLeong0009#intro">Introduction: Recipes, Households, and Everyday Knowledge</a></p>
<p class="toc"><a class="xref" href="#/ChiLeong0010#ch01">CHAPTER 1.  Making Recipe Books in Early Modern England: Material Practices and the Social Production of Knowledge</a></p>
<p class="toc"><a class="xref" href="#/ChiLeong0011#ch02">CHAPTER 2.  Managing Health and Household from Afar</a></p>
<p class="toc"><a class="xref" href="#/ChiLeong0012#ch03">CHAPTER 3.  Collecting Recipes Step-by-Step</a></p>
<p class="toc"><a class="xref" href="#/ChiLeong0013#ch04">CHAPTER 4.  Recipe Trials in the Early Modern Household</a></p>
<p class="toc"><a class="xref" href="#/ChiLeong0014#ch05">CHAPTER 5.  Writing the Family Archive: Recipes and the Paperwork of Kinship</a></p>
<p class="toc"><a class="xref" href="#/ChiLeong0015#ch06">CHAPTER 6.  Recipes for Sale: Intersections between Manuscript and Print Cultures</a></p>
<p class="toc"><a class="xref" href="#/ChiLeong0016#conc">Conclusion: Recipes Beyond the Household</a></p>
<p class="tocbmf"><a class="xref" href="#/ChiLeong0017#acknow">Acknowledgments</a></p>
<p class="tocbm"><a class="xref" href="#/ChiLeong0018#notes">Notes</a></p>
<p class="tocbm"><a class="xref" href="#/ChiLeong0020#biblio">Bibliography</a></p>
<p class="tocbm"><a class="xref" href="#/ChiLeong0021#index">Index</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chi-Leong-0006.vue?7daab8d8